import api from "./api";

export const getPage = async (userId) => {
  const response = await api.get(`/page/${userId}`);
  return response;
};

export const removePage = async (sectionId) => {
  const result = await api.delete(`/page/${sectionId}`);
  return result;
};

export const setPage = async ({
  userId,
  title,
  logo,
  description,
  excerpt,
  color,
  cover,
  delivery,
  ecommerce,
  headerStyle,
  pages
}) => {
  try {
    if (!userId) throw { message: "userId no está definido" };
    const response = await api.post(`/page/${userId}`, {
      title,
      description,
      excerpt,
      color,
      cover,
      logo,
      delivery,
      ecommerce,
      headerStyle,
      pages
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const setNotificationId = async ({ userId, notificationId }) => {
  const result = await api.post(`/page/${userId}`, {
    notificationId,
  });
  return result;
};
